function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "dsg7700j1a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.2 3.2h8.824v8.823h7.955v7.956h8.82v8.823H3.2V3.2z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.024 3.2v-1h1v1h-1zM3.2 3.2h-1v-1h1v1zm8.824 8.823v1h-1v-1h1zm7.955 0v-1h1v1h-1zm0 7.956v1h-1v-1h1zm8.82 0v-1h1v1h-1zm0 8.823h1v1h-1v-1zm-25.599 0v1h-1v-1h1zM12.024 4.2H3.2v-2h8.824v2zm-1 7.489v-8.49h2v8.49h-2zm0 .334v-.334h2v.334h-2zm8.955 1h-7.955v-2h7.955v2zm-1 6.956v-7.956h2v7.956h-2zm9.82 1h-8.82v-2h8.82v2zm-1 7.823V19.98h2v8.823h-2zm-7.82-1h8.82v2h-8.82v-2zm-.003 0h.003v2h-.003v-2zm-7.952 0h7.952v2h-7.952v-2zm-.868 0h.868v2h-.868v-2zm-7.956 0h7.956v2H3.2v-2zm1-7.29v8.29h-2v-8.29h2zm0-.533v.533h-2v-.533h2zm0-7.956v7.956h-2v-7.956h2zm0-.334v.334h-2v-.334h2zm0-8.49v8.49h-2v-8.49h2z",
  fill: "#4E5EFA",
  mask: "url(#dsg7700j1a)"
});

function SvgStepsLine32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsLine32);
export default __webpack_public_path__ + "static/media/steps-line_32.edbc2642.svg";
export { ForwardRef as ReactComponent };